import React from "react";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import Header from "../../sharedScreens/Header";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import MuiSearchSelect from "../../components/basicComponent/MuiSearchSelect";
import { MuiInput } from "../../components/basicComponent/MuiInput";
import MuiButton from "../../components/basicComponent/MuiButton";
import { Checkbox, FormGroup, FormLabel } from "@mui/material";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const AdminConfiguration = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header text-center">
              <h3 className="card-title">General Configuration</h3>
            </div>
            <div className="row">
              <div className="card card-custom">
                <div className=" ">
                  <div className="admin-confg-tabs">
                    <Box
                      sx={{
                        flexGrow: 1,
                        bgcolor: "background.paper",
                        display: "flex",
                        height: "auto",
                        width: "100%"
                      }}
                    >
                      <Tabs
                        orientation="vertical"
                        variant="scrollable"
                        value={value}
                        onChange={handleChange}
                        aria-label="Vertical tabs example"
                        sx={{ borderRight: 1, borderColor: "divider" }}
                      >
                        <Tab label="General Configuration" {...a11yProps(0)} />
                        <Tab label="Website Settings" {...a11yProps(1)} />
                        <Tab label="Email Credential  " {...a11yProps(2)} />
                        <Tab label="Email Configuration" {...a11yProps(3)} />
                        <Tab label="API Configuration" {...a11yProps(4)} />
                      </Tabs>
                      <Box sx={{ width: '100%', maxWidth: '1000px' }}>
                      <TabPanel value={value} index={0} >
                        <div className="row mt-4">
                          <div className="col-md-4">
                            <MuiSearchSelect
                              placeholder={" Business Unit"}
                              label="Business Unit "
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-md-4 ">
                            <MuiSearchSelect
                              label="Branch"
                              placeholder={"Branch"}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-md-4">
                            <MuiSearchSelect
                              label="Customer/Agent Name"
                              placeholder={"Customer/Agent Name"}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                        </div>

                        <div className="card mt-3">
                          <div className="card-body ">
                            <div className="row">
                              <div className="col-xl-4 col-lg-4 col-md-6">
                                <Checkbox /> <label htmlFor="">GST</label>
                              </div>
                              <div className="col-xl-4 col-lg-4 col-md-6">
                                <Checkbox />{" "}
                                <label htmlFor="">Additional Booking Fee</label>
                              </div>
                              <div className="col-xl-4 col-lg-4 col-md-6">
                                <Checkbox />{" "}
                                <label htmlFor="">Additional Markup</label>
                              </div>
                              <div className="col-xl-4 col-lg-4 col-md-6">
                                <Checkbox />{" "}
                                <label htmlFor="">
                                  Additional Service Charge
                                </label>
                              </div>
                            </div>
                            <div className="row mt-3">
                              <div className="col-md-4">
                                <FormLabel
                                  sx={{
                                    color: " #38aecc",
                                    fontWeight: "bold",
                                  }}
                                >
                                  SEO Metatags
                                </FormLabel>

                                <FormGroup
                                  sx={{
                                    border: "1px solid #ccc",
                                    padding: "8px",
                                    borderRadius: "4px",
                                    width: "100%",
                                    height: "auto",
                                  }}
                                >
                                  <div className="row">
                                    <div className="col-xl-12 col-lg-4 col-md-6">
                                      <Checkbox />{" "}
                                      <label htmlFor="">Theme 1</label>
                                    </div>
                                    <div className="col-xl-12 col-lg-4 col-md-6">
                                      <Checkbox />{" "}
                                      <label htmlFor="">Theme 2</label>
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>
                              <div className="col-md-4">
                                <FormLabel
                                  sx={{
                                    color: " #38aecc",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Print Ticket Features
                                </FormLabel>

                                <FormGroup
                                  sx={{
                                    border: "1px solid #ccc",
                                    padding: "8px",
                                    borderRadius: "4px",
                                    width: "100%",
                                    height: "auto",
                                  }}
                                >
                                  <div className="row">
                                    <div className="col-xl-12 col-lg-4 col-md-6">
                                      <Checkbox />{" "}
                                      <label htmlFor="">With Logo</label>
                                    </div>
                                    <div className="col-xl-12 col-lg-4 col-md-6">
                                      <Checkbox />{" "}
                                      <label htmlFor="">With Fare</label>
                                    </div>
                                    <div className="col-xl-12 col-lg-4 col-md-6">
                                      <Checkbox />{" "}
                                      <label htmlFor="">With Branch</label>
                                    </div>
                                    <div className="col-xl-12 col-lg-4 col-md-6">
                                      <Checkbox />{" "}
                                      <label htmlFor="">
                                        With Agency Details
                                      </label>
                                    </div>
                                    <div className="col-xl-12 col-lg-4 col-md-6">
                                      <Checkbox />{" "}
                                      <label htmlFor="">With Breakup</label>
                                    </div>
                                    <div className="col-xl-12 col-lg-4 col-md-6">
                                      <Checkbox />{" "}
                                      <label htmlFor="">With GST</label>
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>
                              <div className="col-md-4">
                                <FormLabel
                                  sx={{
                                    color: " #38aecc",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Default selection option for tickets
                                </FormLabel>

                                <FormGroup
                                  sx={{
                                    border: "1px solid #ccc",
                                    padding: "8px",
                                    borderRadius: "4px",
                                    width: "100%",
                                    height: "auto",
                                  }}
                                >
                                  <div className="row">
                                    <div className="col-xl-12 col-lg-4 col-md-6">
                                      <Checkbox />{" "}
                                      <label htmlFor="">With Logo</label>
                                    </div>
                                    <div className="col-xl-12 col-lg-4 col-md-6">
                                      <Checkbox />{" "}
                                      <label htmlFor="">With Fare</label>
                                    </div>
                                    <div className="col-xl-12 col-lg-4 col-md-6">
                                      <Checkbox />{" "}
                                      <label htmlFor="">With Branch</label>
                                    </div>
                                    <div className="col-xl-12 col-lg-4 col-md-6">
                                      <Checkbox />{" "}
                                      <label htmlFor="">
                                        With Agency Details
                                      </label>
                                    </div>
                                    <div className="col-xl-12 col-lg-4 col-md-6">
                                      <Checkbox />{" "}
                                      <label htmlFor="">With Breakup</label>
                                    </div>
                                    <div className="col-xl-12 col-lg-4 col-md-6">
                                      <Checkbox />{" "}
                                      <label htmlFor="">With GST</label>
                                    </div>
                                  </div>
                                </FormGroup>
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: "10px",
                                marginTop: "8px",
                              }}
                            >
                              <div className="user-button w-full">
                                <MuiButton
                                  className="main-btn get-btn"
                                  variant="contained"
                                  size="large"
                                  type="submit"
                                  label={"Submit"}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </TabPanel>
                      <TabPanel value={value} index={1}>
                        <div className="row">
                          <div className="col-md-4">
                            <FormLabel
                              sx={{
                                color: " #38aecc",
                                fontWeight: "bold",
                              }}
                            >
                              Ticket Copy Format
                            </FormLabel>

                            <FormGroup
                              sx={{
                                border: "1px solid #ccc",
                                padding: "8px",
                                borderRadius: "4px",
                                width: "100%",
                                height: "auto",
                              }}
                            >
                              <div className="row">
                                <div className="col-xl-12 col-lg-4 col-md-6 mb-3">
                                  <MuiSearchSelect
                                    label="Meta Title"
                                    placeholder={"Meta Title"}
                                    options={[]}
                                    onChange={function (
                                      value: string,
                                      id: string,
                                      data: any
                                    ): void {
                                      throw new Error(
                                        "Function not implemented."
                                      );
                                    }}
                                    value={""}
                                  />
                                </div>
                                <div className="col-xl-12 col-lg-4 col-md-6 mb-3">
                                  <MuiSearchSelect
                                    label="Meta keywords"
                                    placeholder={"Meta keywords"}
                                    options={[]}
                                    onChange={function (
                                      value: string,
                                      id: string,
                                      data: any
                                    ): void {
                                      throw new Error(
                                        "Function not implemented."
                                      );
                                    }}
                                    value={""}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                          <div className="col-md-4">
                            <FormLabel
                              sx={{
                                color: " #38aecc",
                                fontWeight: "bold",
                              }}
                            >
                              Social media link
                            </FormLabel>

                            <FormGroup
                              sx={{
                                border: "1px solid #ccc",
                                padding: "8px",
                                borderRadius: "4px",
                                width: "100%",
                                height: "auto",
                              }}
                            >
                              <div className="row">
                                <div className="col-xl-12 col-lg-4 col-md-6 mb-3">
                                  <MuiSearchSelect
                                    label="Facebook Links"
                                    placeholder={"Facebook Links"}
                                    options={[]}
                                    onChange={function (
                                      value: string,
                                      id: string,
                                      data: any
                                    ): void {
                                      throw new Error(
                                        "Function not implemented."
                                      );
                                    }}
                                    value={""}
                                  />
                                </div>
                                <div className="col-xl-12 col-lg-4 col-md-6 mb-3">
                                  <MuiSearchSelect
                                    label="Instagram Links"
                                    placeholder={"Instagram Links"}
                                    options={[]}
                                    onChange={function (
                                      value: string,
                                      id: string,
                                      data: any
                                    ): void {
                                      throw new Error(
                                        "Function not implemented."
                                      );
                                    }}
                                    value={""}
                                  />
                                </div>
                                <div className="col-xl-12 col-lg-4 col-md-6 mb-3">
                                  <MuiSearchSelect
                                    label="Twitter Links"
                                    placeholder={"Twitter Links"}
                                    options={[]}
                                    onChange={function (
                                      value: string,
                                      id: string,
                                      data: any
                                    ): void {
                                      throw new Error(
                                        "Function not implemented."
                                      );
                                    }}
                                    value={""}
                                  />
                                </div>
                                <div className="col-xl-12 col-lg-4 col-md-6 mb-3">
                                  <MuiSearchSelect
                                    label="LinkedIn Links"
                                    placeholder={"LinkedIn Links"}
                                    options={[]}
                                    onChange={function (
                                      value: string,
                                      id: string,
                                      data: any
                                    ): void {
                                      throw new Error(
                                        "Function not implemented."
                                      );
                                    }}
                                    value={""}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                          <div className="col-md-4">
                            <FormLabel
                              sx={{
                                color: " #38aecc",
                                fontWeight: "bold",
                              }}
                            >
                              Contact Details
                            </FormLabel>

                            <FormGroup
                              sx={{
                                border: "1px solid #ccc",
                                padding: "8px",
                                borderRadius: "4px",
                                width: "100%",
                                height: "auto",
                              }}
                            >
                              <div className="row">
                                <div className="col-xl-12 col-lg-4 col-md-6 mb-3">
                                  <MuiSearchSelect
                                    label="Contact Number"
                                    placeholder={"Contact Number"}
                                    options={[]}
                                    onChange={function (
                                      value: string,
                                      id: string,
                                      data: any
                                    ): void {
                                      throw new Error(
                                        "Function not implemented."
                                      );
                                    }}
                                    value={""}
                                  />
                                </div>
                                <div className="col-xl-12 col-lg-4 col-md-6 mb-3">
                                  <MuiSearchSelect
                                    label="EMail"
                                    placeholder={"EMail"}
                                    options={[]}
                                    onChange={function (
                                      value: string,
                                      id: string,
                                      data: any
                                    ): void {
                                      throw new Error(
                                        "Function not implemented."
                                      );
                                    }}
                                    value={""}
                                  />
                                </div>
                                <div className="col-xl-12 col-lg-4 col-md-6 mb-3">
                                  <MuiSearchSelect
                                    label="Address"
                                    placeholder={"Address"}
                                    options={[]}
                                    onChange={function (
                                      value: string,
                                      id: string,
                                      data: any
                                    ): void {
                                      throw new Error(
                                        "Function not implemented."
                                      );
                                    }}
                                    value={""}
                                  />
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                          <div className="col-md-4">
                            <FormLabel
                              sx={{
                                color: " #38aecc",
                                fontWeight: "bold",
                              }}
                            >
                              Footer Theme
                            </FormLabel>

                            <FormGroup
                              sx={{
                                border: "1px solid #ccc",
                                padding: "8px",
                                borderRadius: "4px",
                                width: "100%",
                                height: "auto",
                              }}
                            >
                              <div className="row">
                                <div className="col-xl-12 col-lg-4 col-md-6">
                                  <Checkbox /> <label htmlFor="">Theme 1</label>
                                </div>
                                <div className="col-xl-12 col-lg-4 col-md-6">
                                  <Checkbox /> <label htmlFor="">Theme 2</label>
                                </div>
                              </div>
                            </FormGroup>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              gap: "10px",
                              marginTop: "8px",
                            }}
                          >
                            <div className="user-button w-full">
                              <MuiButton
                                className="main-btn get-btn"
                                variant="contained"
                                size="large"
                                type="submit"
                                label={"Submit"}
                              />
                            </div>
                          </div>
                        </div>
                      </TabPanel>
                      <TabPanel value={value} index={2}>
                        <div className="row">
                          <div className="col-md-4 mt-3">
                            <MuiInput
                              label={"Host Address"}
                              placeholder="Host Address"
                            />
                          </div>
                          <div className="col-md-4 mt-3">
                            <MuiInput
                              label={"Network Username"}
                              placeholder="Network Username"
                            />
                          </div>
                          <div className="col-md-4 mt-3">
                            <MuiInput
                              label={"Mail Username"}
                              placeholder="Mail Username"
                            />
                          </div>
                          <div className="col-md-4 mt-3">
                            <MuiInput
                              label={"Mail Password"}
                              placeholder="Mail Password"
                            />
                          </div>
                          <div className="col-md-4 mt-3">
                            <MuiInput label={"Port No"} placeholder="Port No" />
                          </div>
                          <div className="col-md-4 mt-3">
                            <MuiInput
                              label={"Enable SSL"}
                              placeholder="Enable SSL"
                            />
                          </div>
                          <div className="col-md-4 mt-3">
                            <MuiInput
                              label={"Header Text"}
                              placeholder="Header Text"
                            />
                          </div>

                          <div className="row mt-3">
                            <div className="card card-grid">
                              <div className="card-body">
                                <div
                                  style={{
                                    overflowX: "scroll",
                                    maxWidth: "100%",
                                  }}
                                >
                                  <table className="table table-bordered align-middle text-center">
                                    <thead>
                                      <tr>
                                        <th>Action</th>
                                        <th className="min-w-[100px]">
                                          Test Email
                                        </th>
                                        <th>Status</th>
                                        <th>Header</th>
                                        <th className="min-w-[100px]">
                                          {" "}
                                          Address
                                        </th>
                                        <th>Network User Name</th>
                                        <th>Mail User Name</th>
                                        <th>Mail Password</th>
                                        <th>Enable </th>
                                        <th>Port</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td className="action-icons">
                                          <i className="bi bi-pencil-square text-warning" />
                                          <i className="bi bi-trash text-danger" />
                                        </td>
                                        <td>
                                          <span className="text-blue">
                                            Test Email
                                          </span>
                                        </td>
                                        <td>
                                          <span className="text-green">
                                            Verified
                                          </span>
                                        </td>
                                        <td />
                                        <td>Email.</td>
                                        <td>AKIA3BCJECZLY26G5TOW</td>
                                        <td>Ticket@Ewts.Ae</td>
                                        <td>BGUF3F/Mjwjyy8e7...</td>
                                        <td>true</td>
                                        <td>587</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              gap: "10px",
                              marginTop: "8px",
                            }}
                          >
                            <div className="user-button w-full">
                              <MuiButton className="clear-btn " label="Clear" />
                              <MuiButton
                                className="main-btn get-btn"
                                variant="contained"
                                size="large"
                                type="submit"
                                label={"Submit"}
                              />
                            </div>
                          </div>
                        </div>
                      </TabPanel>
                      <TabPanel value={value} index={3}>
                        <div className="row mt-4">
                          <div className="col-md-4">
                            <MuiSearchSelect
                              placeholder={" Business Unit"}
                              label="Business Unit "
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-md-4 ">
                            <MuiSearchSelect
                              label="Branch"
                              placeholder={"Branch"}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-md-4">
                            <MuiSearchSelect
                              label="Customer/Agent Name"
                              placeholder={"Customer/Agent Name"}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                        </div>
                        <div className="row mt-4">
                          <FormLabel
                            sx={{
                              color: " #38aecc",
                              fontWeight: "bold",
                            }}
                          >
                            <div className="row">
                              <div className="col-md-3 user-manage-model">
                                <MuiSearchSelect
                                  placeholder={"All"}
                                  options={[]}
                                  onChange={function (
                                    value: string,
                                    id: string,
                                    data: any
                                  ): void {
                                    throw new Error(
                                      "Function not implemented."
                                    );
                                  }}
                                  value={""}
                                />
                              </div>
                            </div>
                          </FormLabel>

                          <FormGroup
                            sx={{
                              border: "1px solid #ccc",
                              padding: "8px",
                              borderRadius: "4px",
                              width: "100%",
                              height: "auto",
                            }}
                          >
                            <div className="row">
                              <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                                <MuiSearchSelect
                                  label="product"
                                  placeholder={"product"}
                                  options={[]}
                                  onChange={function (
                                    value: string,
                                    id: string,
                                    data: any
                                  ): void {
                                    throw new Error(
                                      "Function not implemented."
                                    );
                                  }}
                                  value={""}
                                />
                              </div>
                              <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                                <MuiSearchSelect
                                  label="Mail From"
                                  placeholder={"Mail From"}
                                  options={[]}
                                  onChange={function (
                                    value: string,
                                    id: string,
                                    data: any
                                  ): void {
                                    throw new Error(
                                      "Function not implemented."
                                    );
                                  }}
                                  value={""}
                                />
                              </div>
                              <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                                <MuiSearchSelect
                                  label="Meta keywords"
                                  placeholder={"Meta keywords"}
                                  options={[]}
                                  onChange={function (
                                    value: string,
                                    id: string,
                                    data: any
                                  ): void {
                                    throw new Error(
                                      "Function not implemented."
                                    );
                                  }}
                                  value={""}
                                />
                              </div>
                              <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                                <MuiSearchSelect
                                  label="Meta keywords"
                                  placeholder={"Meta keywords"}
                                  options={[]}
                                  onChange={function (
                                    value: string,
                                    id: string,
                                    data: any
                                  ): void {
                                    throw new Error(
                                      "Function not implemented."
                                    );
                                  }}
                                  value={""}
                                />
                              </div>
                              <div className="col-xl-3 col-lg-4 col-md-6 mb-3">
                                <MuiSearchSelect
                                  label="Meta keywords"
                                  placeholder={"Meta keywords"}
                                  options={[]}
                                  onChange={function (
                                    value: string,
                                    id: string,
                                    data: any
                                  ): void {
                                    throw new Error(
                                      "Function not implemented."
                                    );
                                  }}
                                  value={""}
                                />
                              </div>
                              <div className="col-xl-6 col-lg-4 col-md-6 mb-3">
                                <MuiSearchSelect
                                  label="Meta keywords"
                                  placeholder={"Meta keywords"}
                                  options={[]}
                                  onChange={function (
                                    value: string,
                                    id: string,
                                    data: any
                                  ): void {
                                    throw new Error(
                                      "Function not implemented."
                                    );
                                  }}
                                  value={""}
                                />
                              </div>
                            </div>
                          </FormGroup>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              gap: "10px",
                              marginTop: "8px",
                            }}
                          >
                            <div className="user-button w-full">
                              <MuiButton className="clear-btn " label="Clear" />
                              <MuiButton
                                className="main-btn get-btn"
                                variant="contained"
                                size="large"
                                type="submit"
                                label={"Insert"}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row mt-3">
                          <div className="card card-grid">
                            <div className="card-body">
                              <div
                                style={{
                                  overflowX: "scroll",
                                  maxWidth: "100%",
                                }}
                              >
                                <table className="table table-bordered align-middle text-center">
                                  <thead>
                                    <tr>
                                      <th>Action</th>
                                      <th className="min-w-[100px]">
                                        Test Email
                                      </th>
                                      <th>Status</th>
                                      <th>Header</th>
                                      <th className="min-w-[100px]">
                                        {" "}
                                        Address
                                      </th>
                                      <th>Network User Name</th>
                                      <th>Mail User Name</th>
                                      <th>Mail Password</th>
                                      <th>Enable </th>
                                      <th>Port</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td className="action-icons">
                                        <i className="bi bi-pencil-square text-warning" />
                                        <i className="bi bi-trash text-danger" />
                                      </td>
                                      <td>
                                        <span className="text-blue">
                                          Test Email
                                        </span>
                                      </td>
                                      <td>
                                        <span className="text-green">
                                          Verified
                                        </span>
                                      </td>
                                      <td />
                                      <td>Email.</td>
                                      <td>AKIA3BCJECZLY26G5TOW</td>
                                      <td>Ticket@Ewts.Ae</td>
                                      <td>BGUF3F/Mjwjyy8e7...</td>
                                      <td>true</td>
                                      <td>587</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </TabPanel>
                      <TabPanel value={value} index={4}>
                        <div className="row mt-4">
                          <div className="col-md-4">
                            <MuiSearchSelect
                              placeholder={" Business Unit"}
                              label="Business Unit "
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-md-4 ">
                            <MuiSearchSelect
                              label="Branch"
                              placeholder={"Branch"}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-md-4">
                            <MuiSearchSelect
                              label="Customer/Agent Name"
                              placeholder={"Customer/Agent Name"}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-md-4 mt-3">
                            <MuiSearchSelect
                              placeholder={" Module "}
                              label="Module  "
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-md-4  mt-3">
                            <MuiSearchSelect
                              label="Stock Type "
                              placeholder={"Stock Type "}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-md-4 mt-3">
                            <MuiSearchSelect
                              label="Airline Name"
                              placeholder={"Airline Name"}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>
                          <div className="col-md-4 mt-3">
                            <MuiSearchSelect
                              label="Airport Type"
                              placeholder={"Airport Type"}
                              options={[]}
                              onChange={function (
                                value: string,
                                id: string,
                                data: any
                              ): void {
                                throw new Error("Function not implemented.");
                              }}
                              value={""}
                            />
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              gap: "10px",
                              marginTop: "8px",
                            }}
                          >
                            <div className="user-button w-full">
                              <MuiButton className="clear-btn " label="Clear" />
                              <MuiButton
                                className="main-btn get-btn"
                                variant="contained"
                                size="large"
                                type="submit"
                                label={"Submit"}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="card card-grid">
                            <div className="card-body">
                              <div
                                style={{
                                  overflowX: "scroll",
                                  maxWidth: "1100px",
                                }}
                              >
                                <table className="table table-bordered align-middle text-center">
                                  <thead>
                                    <tr>
                                      <th className="min-w-[100px]">Action</th>
                                      <th className="min-w-[100px]">
                                        Module Type
                                      </th>
                                      <th className="min-w-[150px]">
                                        Business Unit
                                      </th>
                                      <th className="min-w-[100px]">
                                        Customer Name
                                      </th>
                                      <th className="min-w-[100px]">
                                        Stock Type
                                      </th>
                                      <th className="min-w-[150px]">
                                        Airline Name
                                      </th>
                                      <th className="min-w-[100px]">
                                        Airport Type
                                      </th>
                                      <th className="min-w-[150px]">
                                        Airline Category
                                      </th>
                                      <th className="min-w-[100px]">
                                        Fare Type
                                      </th>
                                      <th className="min-w-[150px]">
                                        Origin Include
                                      </th>
                                      <th className="min-w-[150px]">
                                        Origin Exclude
                                      </th>
                                      <th className="min-w-[150px]">
                                        Destination Include
                                      </th>
                                      <th className="min-w-[200px]">
                                        Destination Exclude
                                      </th>
                                      <th className="min-w-[150px]">
                                        Origin Country
                                      </th>
                                      <th className="min-w-[150px]">
                                        Destination Country
                                      </th>
                                      <th className="min-w-[150px]">
                                        Product Class
                                      </th>
                                      <th className="min-w-[200px]">
                                        FareType Description
                                      </th>
                                      <th className="min-w-[150px]">
                                        SSR TYPE
                                      </th>
                                      <th className="min-w-[150px]">
                                        GST Type
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>Edit/Delete</td>
                                      <td>DOBMANDATORY</td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td>Edit/Delete</td>
                                      <td>DOBMANDATORY</td>
                                      <td>B2B</td>
                                      <td>Demo-EEAUH0000101</td>
                                      <td>OSC</td>
                                      <td>0K</td>
                                      <td>DOMESTIC</td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td>Edit/Delete</td>
                                      <td>PASSPORTMANDATORY</td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </TabPanel>
                      </Box>
                    </Box>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminConfiguration;
